import { Theme, useMediaQuery } from "@securitize/reactjs-whm";
import SettingsDesktop from "./components/SettingsDesktop";
import SettingsMobile from "./components/SettingsMobile";
import { useContext } from "react";
import { ProfileContext } from "../../../contexts/ProfileContext";
import { ProfilePermissionType } from "../../../data/dtos/profile-config.dto";
import { useGetInvestorInformationQuery } from "../../../data/useProfile";

interface SettingsProps {
  isPendingActionsLoading: boolean;
  permission: ProfilePermissionType;
}

export default function Settings({
  permission,
  isPendingActionsLoading,
}: SettingsProps) {
  const isMobile = useMediaQuery((theme: Theme) =>
    theme.breakpoints.down("xl"),
  );

  const contextValues = useContext(ProfileContext);
  const investorInformationQuery = useGetInvestorInformationQuery({
    enabled: true,
  });

  const props = {
    isLoading: isPendingActionsLoading || contextValues.sessions.isLoading,
    permission,
    displayableId: investorInformationQuery.data?.displayableId,
    ...contextValues,
  };

  return isMobile ? (
    <SettingsMobile {...props} />
  ) : (
    <SettingsDesktop {...props} />
  );
}
